import { ActionType } from "../../../../../../../../react-core/Flux/ActionType";
import { Dispatcher } from "../../../../../../../../react-core/Flux/Dispatcher";
import { ProductDetailsStatic } from "./ProductDetailsStatic";



export interface FluxResponse {
    actionType: ActionType;
    isLoading?: boolean;
    payload?: any;
    otherObj?: any;
}

export const ProductDetailsDispatcher: Dispatcher<FluxResponse> = new Dispatcher<FluxResponse>();
export const ProductDetailsStore: ProductDetailsStatic = new ProductDetailsStatic();